import { fromTemplate } from '../../utils/dom.js';
import './ai-lab.css';

export class AiLab {
  render() {
    const template = `
      <section class="sl-ailab" id="ai-lab" data-testid="ai-lab">
        <div class="container sl-ailab__inner">
          <span class="sl-ailab__badge" data-testid="ai-lab-badge">Coming soon</span>
          <h2 class="sl-ailab__title" data-testid="ai-lab-title">
            Striking Labs <span class="sl-ailab__accent">AI Lab</span>
          </h2>
          <p class="sl-ailab__lede" data-testid="ai-lab-lede">
            We&rsquo;re building a new home for experiments at the intersection
            of design, language models, and native apps. Tools that respect
            your attention &mdash; and your data.
          </p>
        </div>
      </section>
    `;
    return fromTemplate(template);
  }
}
